import { css } from "@emotion/react";

export const borderedSectionStyles = ({ borderedSection }, { isThick }) => css`
  padding: ${isThick ? "1.5rem" : "1rem"};
  border-radius: 5px;
  border: 1px solid ${borderedSection.borderColor};
`;
